import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lp2-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.scss'],
})
export class GenericModalComponent {
  @Input()
  title: string;

  @Input()
  body: string;

  @Output()
  close = new EventEmitter();
}



// WEBPACK FOOTER //
// ./ts/app/shared/generic-modal/generic-modal.component.ts